angular.module('rjmNg.directives').directive "emailSummaryList", [
  () ->
    restrict: "E"
    templateUrl: "directive.emailSummaryList.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      message: "="
    controller: [
      "$q"
      "$url"
      "app"
      "appRoute"
      "EmailSummary"
      "emailSummaryEnums"
      "errorConstants"
      "Figures"
      "notification"
      (
        $q
        $url
        app
        appRoute
        EmailSummary
        emailSummaryEnums
        errorConstants
        Figures
        notification
      ) ->

        view = @
        _allowedSortColumns = ['name', 'created', 'statusSortOrder']
        BASE_URL = "/settings/email-summary/edit"
        _esToRemove = null
        _notificationScope = "emailSummaryList"
        _notificationTimeout = 20
        _schedule_frequencies = []
        _sortClass = {
          unsorted : 'mbi-table__sort-none'
          asc : 'mbi-table__sort-asc'
          desc : 'mbi-table__sort-desc'
        }
        STATUSE_NAMES = emailSummaryEnums.STATUSE_NAMES
        
        view.ADD_EMAIL_SUMMARY_IMAGE_URL = $url("/images/add-email-summary.svg")
        view.BS_TOOLTIP_TITLE = "Email will send to everyone included on the recipient list."
        view.createESUrl = appRoute(BASE_URL)
        view.createdSortClass = _sortClass.unsorted
        view.DELETE_MODAL_ID = "deleteEmailSummaryModal"
        view.deleteLoading = false
        view.es = []
        view.FREQUENCIES = emailSummaryEnums.NEW_FREQUENCIES
        view.loading = false
        view.nameSortClass = _sortClass.unsorted
        view.sortProp = 'created'
        view.sortReverse = 'true'
        view.STATUSES = emailSummaryEnums.STATUSES
        view.statusSortClass = _sortClass.unsorted

        _checkIfExpired = (es) ->
          isExpired = false
          if (es.status is view.STATUSES.ACTIVE and es.schedule.end_date and moment(es.schedule.end_date).isBefore())
            isExpired = true
          return isExpired

        _getStatusSortOrder = (es) ->
          sortResult = es.status
          if(es.schedule.frequency is 0)
            sortResult = 0
          return sortResult

        _hideDeleteEmailSummaryModal = () ->
          _esToRemove = null
          view.deleteLoading = false
          $("##{view.DELETE_MODAL_ID}").modal("hide")
          return

        _notify = (type, message, clearNotificationScope = false, dismissable = true, notificationTimeout = _notificationTimeout, scope = _notificationScope) ->
          notifyFn = notification.info
          switch type
            when 'error' then notifyFn = notification.error
            when 'success' then notifyFn = notification.success
            else notifyFn = notification.info
          if clearNotificationScope then notification.clear(_notificationScope)
          notifyFn(
            type,
            message
            scope
            {dismissable: dismissable}
            notificationTimeout
          )
          return     

        _setESStatus = (es, status) ->
          es.status = status
          es.display.status = STATUSE_NAMES[es.status]
          return
        
        _setSortClasses = () ->
          tmpSortClass = if view.sortReverse then _sortClass.asc else _sortClass.desc
          view.nameSortClass = _sortClass.unsorted
          view.createdSortClass = _sortClass.unsorted
          view.statusSortClass = _sortClass.unsorted
          switch view.sortProp
            when 'name' then view.nameSortClass = tmpSortClass
            when 'created' then view.createdSortClass = tmpSortClass
            when 'statusSortOrder' then view.statusSortClass = tmpSortClass

        _showDeleteEmailSummaryModal = (es) ->
          _esToRemove = es
          $("##{view.DELETE_MODAL_ID}").modal()
          return

        _sortESList = (sortCol) ->
          if(sortCol is view.sortProp)
            view.sortReverse = not view.sortReverse
          else
            if(_.contains(_allowedSortColumns, sortCol))
              view.sortReverse = false
              view.sortProp = sortCol
          _setSortClasses()

        _updateStatus = (es, status, successMessage) ->
          view.loading = true
          EmailSummary.update(
            es.id
            es_map: {status: status}
          ).then(
            (success) ->
              _setESStatus(es, status)
              es.isExpired = _checkIfExpired(es)
              _notify("success", "Email Summary <strong>\"" + es.name + "\"</strong> " + successMessage)
            , (error) ->
              _notify("error", errorConstants.SERVER_ERROR_MESSAGE)
          ).finally(() ->
            view.loading = false
          )
          return

        view.activateEmailSummary = (es) ->
          _updateStatus(es, view.STATUSES.ACTIVE, "is activated.")
          return

        view.expandEmailSummary = (es) ->
          es.isExpanded = !es.isExpanded

        view.pauseEmailSummary = (es) ->
          _updateStatus(es, view.STATUSES.PAUSED, "is paused.")
          return

        view.deleteEmailSummary = (es) ->
          _showDeleteEmailSummaryModal(es)
          return

        view.confirmDeleteEmailSummary = () ->
          view.deleteLoading = true
          EmailSummary.update(
            _esToRemove.id
            es_map: {status: view.STATUSES.DELETED}
          ).then(
            (success) ->
              _notify("success", "Email Summary <strong>\"" + _esToRemove.name + "\"</strong> is deleted.")
              _indexToRemove = _.findIndex(
                view.es
                (es) -> es.id is _esToRemove.id
              )
              view.es.splice(_indexToRemove, 1)
            , (error) ->
              _notify("error", errorConstants.SERVER_ERROR_MESSAGE)
          ).finally(() ->
            _hideDeleteEmailSummaryModal()
            view.deleteloading = false
          )
          return

        view.cancelDeleteEmailSummary = () ->
          _hideDeleteEmailSummaryModal()
          return

        view.sendNowEmailSummary = (es, event) ->
          view.loading = true
          EmailSummary.send(es.id).then((success) ->
            _notify("success", "Email Summary <strong>\"" + es.name.replace( /(<([^>]+)>)/ig, '') + "\"</strong> is queued to send.")
          , (error) ->
            _notify("error", "Error sending email.")
          ).finally(() ->
            view.loading = false
          )
          return

        view.changeSort = (sortCol) ->
          _sortESList(sortCol)

        view.$postLink = () ->
          view.loading = true
          $q.all({
            es: EmailSummary.getAll()
            es_metadata: EmailSummary.getMetaData()
            figures: Figures.getAllFigures()
            es_migrated: EmailSummary.getMigrated()
          }).then(
            (success) ->
              _allReports = angular.copy(success.figures)
              _allReportsMap = _allReports.reduce((accu, report) ->
                accu[report.id] = report
                return accu
              ,{})

              _schedule_frequencies = success.es_metadata.data.schedule_frequencies
                .reduce((accu, item) ->
                  accu[item.key] =
                    name: item.display_name
                  return accu
                ,{})

              _migratedIDSet = new Set(success.es_migrated.data.map((es) ->
                return es.id
              ))

              view.es = success.es.filter((es) -> !_migratedIDSet.has(es.id)).map((es) ->
                email_summary = angular.copy(es.email_summary)
                email_summary.id = es.id
                email_summary.isExpanded = false
                email_summary.display = {}
                email_summary.isExpired = _checkIfExpired(email_summary)
                email_summary.reportError = false
                # Display Items
                email_summary.display.items = email_summary.items.map((item) ->
                  _foundRep = _allReportsMap[item.item_id]
                  unless (_foundRep)
                    email_summary.reportError = true
                    _foundRep = 
                      id: item.item_id
                      name: 'Error Finding Report ID: ' + item.item_id
                      reportError: true
                  return _foundRep
                )

                # Display Bccs
                _tmpRecipients = angular.copy(email_summary.bccs)
                if email_summary.send_to_me
                  _tmpRecipients.unshift(app.getUser().email.toLowerCase())
                email_summary.display.bccs = _.uniq(_tmpRecipients)

                # Display Schedule
                _frequency = email_summary.schedule.frequency
                _dispatch_time = email_summary.schedule.dispatch_time
                _start_date = email_summary.schedule.start_date
                _tempName = _schedule_frequencies[_frequency].name
                _longName = _tempName
                switch _frequency
                  when view.FREQUENCIES.DAILY then \
                    _longName = _tempName + moment(_dispatch_time, 'hh:mm').format(' hh:mm a')
                  when view.FREQUENCIES.WEEKLY then \
                    _longName = "Every" + moment(_start_date, 'YYYY-MM-DD').format(' dddd')
                  when view.FREQUENCIES.MONTHLY then \
                    _longName = _tempName + " on the " + moment(_start_date, 'YYYY-MM-DD').format('Do')
                  when view.FREQUENCIES.YEARLY then \
                    _longName = _tempName + " on " + moment(_start_date, 'YYYY-MM-DD').format('MMM Do')
                  else _longName = _tempName
                email_summary.display.schedule =
                  name: _tempName
                  longName: _longName

                # Display Status
                email_summary.display.status = STATUSE_NAMES[email_summary.status]

                # URLs
                email_summary.display.editUrl = appRoute(BASE_URL + "/" + email_summary.id)
                # email_summary.display.cloneUrl = view.createESUrl

                #Set Order for when Order by Status
                email_summary.statusSortOrder = _getStatusSortOrder(email_summary)

                return email_summary
              )
            , (error) ->
              _notify("error", errorConstants.SERVER_ERROR_MESSAGE, true, false, null)
          ).finally(() ->
            view.loading = false
          )


        return view
    ]
]
